import React from 'react'
import Icon from 'react-icon-base'

const Language = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Language" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Language" transform="translate(-128.000000, -2737.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)">
          <g id="Language" transform="translate(0.000000, 2137.000000)">
            <rect
              id="Rectangle-Copy-2"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="439"
              rx="4"
            />
            <g id="Group-18" transform="translate(30.000000, 190.000000)" stroke="#3498DB">
              <g id="Group" transform="translate(66.000000, 0.000000)">
                <path
                  d="M24.1818182,11.5151515 C27.7065728,11.5151515 30.9036285,12.6943498 33.2155662,14.6209646 C35.444493,16.4784036 36.8484848,19.0369838 36.8484848,21.8787879 C36.8484848,24.9249497 35.2352116,27.6458994 32.7219431,29.5264167 L32.7219431,29.5264167 L33.5676031,33.1143984 L29.448431,31.3044584 C27.8414903,31.9079172 26.0585616,32.2424242 24.1818182,32.2424242 C20.6570636,32.2424242 17.4600079,31.0632259 15.1480702,29.1366112 C12.9191434,27.2791722 11.5151515,24.7205919 11.5151515,21.8787879 C11.5151515,19.0369838 12.9191434,16.4784036 15.1480702,14.6209646 C17.4600079,12.6943498 20.6570636,11.5151515 24.1818182,11.5151515 Z"
                  id="Combined-Shape-Copy"
                  strokeWidth="2.3030303"
                />
                <path
                  d="M13.8181818,1.15151515 C17.3429364,1.15151515 20.5399921,2.33071346 22.8519298,4.25732824 C25.0808566,6.11476719 26.4848485,8.67334748 26.4848485,11.5151515 C26.1046658,11.527591 25.7207408,11.5151515 25.3333333,11.5151515 C21.5346889,11.5151515 18.0730682,12.7116072 15.4474575,14.6647856 C13.0563958,16.4434842 11.3581301,18.8468539 10.6845272,21.5579556 C10.2543167,21.4684835 9.83263492,21.3606233 9.42079969,21.235564 L9.42079969,21.235564 L8.53240585,20.9492423 L4.43239693,22.750762 L5.27805686,19.1627804 C2.76478844,17.2822631 1.15151515,14.5613133 1.15151515,11.5151515 C1.15151515,8.67334748 2.55550704,6.11476719 4.78443379,4.25732824 C7.09637152,2.33071346 10.2934272,1.15151515 13.8181818,1.15151515 Z"
                  id="Combined-Shape"
                  strokeWidth="2.3030303"
                />
                <g
                  id="Group-2"
                  transform="translate(15.000000, 17.500000)"
                  strokeLinecap="round"
                  strokeWidth="1.15151515">
                  <line x1="1.72727273" y1="0.575757576" x2="6.33333333" y2="0.575757576" id="Line-2" />
                  <line x1="8.63636364" y1="0.575757576" x2="9.78787879" y2="0.575757576" id="Line-2" />
                  <line x1="12.0909091" y1="0.575757576" x2="15.5454545" y2="0.575757576" id="Line-2-Copy" />
                  <line x1="0.575757576" y1="4.03030303" x2="1.72727273" y2="4.03030303" id="Line-2-Copy-2" />
                  <line x1="1.72727273" y1="7.48484848" x2="7.48484848" y2="7.48484848" id="Line-2-Copy-5" />
                  <line x1="9.78787879" y1="7.48484848" x2="12.0909091" y2="7.48484848" id="Line-2-Copy-6" />
                  <line x1="14.3939394" y1="7.48484848" x2="15.5454545" y2="7.48484848" id="Line-2-Copy-7" />
                  <line x1="4.03030303" y1="4.03030303" x2="12.0909091" y2="4.03030303" id="Line-2-Copy-3" />
                  <line x1="14.3939394" y1="4.03030303" x2="17.8484848" y2="4.03030303" id="Line-2-Copy-4" />
                </g>
                <g
                  id="Group-3"
                  transform="translate(4.606061, 7.000000)"
                  strokeLinecap="round"
                  strokeWidth="1.15151515">
                  <line
                    x1="1.72727273"
                    y1="0.575757576"
                    x2="6.33333333"
                    y2="0.575757576"
                    id="Line-2-Copy-8"
                    transform="translate(4.030303, 0.575758) scale(-1, 1) translate(-4.030303, -0.575758) "
                  />
                  <line
                    x1="8.63636364"
                    y1="0.575757576"
                    x2="9.78787879"
                    y2="0.575757576"
                    id="Line-2-Copy-9"
                    transform="translate(9.212121, 0.575758) scale(-1, 1) translate(-9.212121, -0.575758) "
                  />
                  <line
                    x1="12.0909091"
                    y1="0.575757576"
                    x2="15.5454545"
                    y2="0.575757576"
                    id="Line-2-Copy-10"
                    transform="translate(13.818182, 0.575758) scale(-1, 1) translate(-13.818182, -0.575758) "
                  />
                  <line
                    x1="0.575757576"
                    y1="4.03030303"
                    x2="1.72727273"
                    y2="4.03030303"
                    id="Line-2-Copy-11"
                    transform="translate(1.151515, 4.030303) scale(-1, 1) translate(-1.151515, -4.030303) "
                  />
                  <line
                    x1="1.72727273"
                    y1="7.48484848"
                    x2="7.48484848"
                    y2="7.48484848"
                    id="Line-2-Copy-12"
                    transform="translate(4.606061, 7.484848) scale(-1, 1) translate(-4.606061, -7.484848) "
                  />
                  <line
                    x1="9.78787879"
                    y1="7.48484848"
                    x2="12.0909091"
                    y2="7.48484848"
                    id="Line-2-Copy-13"
                    transform="translate(10.939394, 7.484848) scale(-1, 1) translate(-10.939394, -7.484848) "
                  />
                  <line
                    x1="4.03030303"
                    y1="4.03030303"
                    x2="12.0909091"
                    y2="4.03030303"
                    id="Line-2-Copy-15"
                    transform="translate(8.060606, 4.030303) scale(-1, 1) translate(-8.060606, -4.030303) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

Language.defaultProps = {
  size: 30
}

export default Language
